/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	01-03-2018
	- [ADDED] Added document.ready to onready.
	26-02-2018
	- [ADDED] Open en Close methods are extended with new function to prevent body scrolling when menu is open
2017
	30-11-2017
	- [CHANGE] .js-menu-button is now changed to .js-mobile-menu-button
	15-10-2017
	- [METHOD] Add and remove .active class to the js-menu-button.
	30-08-2017
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/

var specific_showcase = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	// none

	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	this.onready = function () {

		// Init desktop scroller
		if (window.innerWidth >= 1024) {
			this.initDesktop();
		} else {
			this.initMobile();
		}

		// Resize handler
		$(window).on('resize', function () {
			if (window.innerWidth >= 1024) {
				specific_showcase.initDesktop();
			} else {
				specific_showcase.initMobile();
			}
		});

	};

	/*
	Desktop scroller *******************************************
	Desktop scroller *******************************************
	Desktop scroller *******************************************
	Desktop scroller *******************************************
	*/
	this.initDesktop = function () {
		var cloneScrollTimers = {};
		var lastScrollTop = {};

		// Remove any existing handlers first
		$(window).off('wheel.showcase');
		$('.column, .column-mobile').off('scroll.showcase');

		$.ajax({
			url: globalUrl + '/' + _language + '/a/l/showcase-desktop',
			headers: { 'go-load': 1 }
		})
			.done(function (data) {

				/*
				Set HTML
				*/
				$('.js-showcase-desktop').html(data);
				$('.js-showcase-mobile').html('');

				/*
				Stop all mobile scroll events
				*/
				$('.column-mobile').off('scroll');

				// Initieer per kolom de originele content (als array)
				$('.column').each(function () {
					var $col = $(this);

					var $original = $col.find('.is-original').toArray().map(function (el) {
						return $(el).clone();
					});

					$col.data('originalContent', $original);

					/*
					Clone items upfront 1 time
					*/
					$original.forEach(function ($cloned) {
						$col.append($cloned.clone().addClass('is-clone'));
					});

				});

				// Scrollhandler per kolom
				$('.column').on('scroll.showcase', function () {
					var $col = $(this);
					var el = this;
					var id = $col.index();
					var $original = $col.data('originalContent');

					clearTimeout(cloneScrollTimers[id]);

					cloneScrollTimers[id] = setTimeout(function () {
						var scrollTop = el.scrollTop;
						var scrollHeight = el.scrollHeight;
						var clientHeight = el.clientHeight;

						// anti-loop check
						if (lastScrollTop[id] === scrollTop) return;
						lastScrollTop[id] = scrollTop;

						// Increase threshold for smoother experience
						var nearBottom = scrollTop + clientHeight >= scrollHeight - 100; // Increased from 50
						var nearTop = scrollTop <= 100; // Increased from 50

						// CLONE ONDERAAN
						if (nearBottom) {
							$original.forEach(function ($cloned) {
								$col.append($cloned.clone().addClass('is-clone'));
							});
						}

						// CLONE BOVENAAN
						if (nearTop) {
							// Stop any ongoing GSAP animations to prevent conflicts
							gsap.killTweensOf(el);

							var prevHeight = el.scrollHeight;
							var prevScrollTop = el.scrollTop;

							// Add clones at the top
							for (var i = $original.length - 1; i >= 0; i--) {
								$col.prepend($original[i].clone().addClass('is-clone'));
							}

							// Na toevoegen van clones:
							var maxClones = 40;
							$col.find('.is-clone').slice(0, -maxClones).remove(); // alleen de laatste X houden

							var newHeight = el.scrollHeight;
							var heightDifference = newHeight - prevHeight;

							// Adjust scroll position to maintain visual position
							el.scrollTop = prevScrollTop + heightDifference;

							// Update the last scroll position to prevent loops
							lastScrollTop[id] = el.scrollTop;
						}

					}, 200); // Increased from 100ms for less frequent checks
				});

				// USER SCROLL BOOST MET RICHTING
				$(window).on('wheel.showcase', function (e) {
					e.preventDefault();

					var delta = e.originalEvent.deltaY;
					var direction = delta > 0 ? 1 : -1;

					$('.column').each(function (index, el) {
						gsap.killTweensOf(el);

						// Smaller, more responsive boost
						var boostAmount = delta * 3.5; // Reduced from 3.5

						var target = el.scrollTop + boostAmount;

						gsap.to(el, {
							scrollTop: target,
							duration: 0.8, // Slightly longer for smoothness
							ease: "power2.out",
							onComplete: function () {
								specific_showcase.restartAutoScroll(el, direction);
							}
						});
					});
				});

				/*
				Autoscroll
				*/
				$('.column').each(function () {
					var $col = $(this);
					var scrollHeight = this.scrollHeight;
					this.scrollTop = scrollHeight * 0.50;

					var el = this;
					specific_showcase.restartAutoScroll(el);
				});

			})
			.always(function () {
			});

	};

	/*
	Mobile scroller *******************************************
	Mobile scroller *******************************************
	Mobile scroller *******************************************
	Mobile scroller *******************************************
	*/
	this.initMobile = function () {
		var cloneScrollTimers = {};
		var lastScrollTop = {};

		// Remove any existing handlers first
		$(window).off('wheel.showcase');
		$('.column, .column-mobile').off('scroll.showcase');

		$.ajax({
			url: globalUrl + '/' + _language + '/a/l/showcase-mobile',
			headers: { 'go-load': 1 }
		})
			.done(function (data) {

				/*
				Set HTML
				*/
				$('.js-showcase-mobile').html(data);
				$('.js-showcase-desktop').html('');

				/*
				Stop all desktop scroll events and remove HTML
				*/
				$('.column').off('scroll');

				// Initieer per kolom de originele content (als array)
				$('.column-mobile').each(function () {
					var $col = $(this);

					var $originalMobile = $col.find('.is-original').toArray().map(function (el) {
						return $(el).clone();
					});

					$col.data('originalContent', $originalMobile);

					/*
					Clone items upfront 1 time
					*/
					$originalMobile.forEach(function ($cloned) {
						$col.append($cloned.clone().addClass('is-clone'));
					});

				});

				// Scrollhandler voor mobiele scrollers
				$('.column-mobile').on('scroll.showcase', function () {
					var $col = $(this);
					var el = this;
					var id = $col.index();
					var $original = $col.data('originalContent');

					clearTimeout(cloneScrollTimers[id]);

					cloneScrollTimers[id] = setTimeout(function () {
						var scrollTop = el.scrollTop;
						var scrollHeight = el.scrollHeight;
						var clientHeight = el.clientHeight;

						// anti-loop check
						if (lastScrollTop[id] === scrollTop) return;
						lastScrollTop[id] = scrollTop;

						var nearBottom = scrollTop + clientHeight >= scrollHeight - 50;
						var nearTop = scrollTop <= 50;

						// CLONE ONDERAAN
						if (nearBottom) {
							$original.forEach(function ($cloned) {
								$col.append($cloned.clone().addClass('is-clone'));
							});
						}

						// CLONE BOVENAAN
						if (nearTop) {
							// Stop any ongoing GSAP animations to prevent conflicts
							gsap.killTweensOf(el);

							var prevHeight = el.scrollHeight;
							var prevScrollTop = el.scrollTop;

							// Add clones at the top
							for (var i = $original.length - 1; i >= 0; i--) {
								$col.prepend($original[i].clone().addClass('is-clone'));
							}

							// Na toevoegen van clones:
							var maxClones = 40;
							$col.find('.is-clone').slice(maxClones).remove(); // alleen de eerste X houden

							var newHeight = el.scrollHeight;
							var heightDifference = newHeight - prevHeight;

							// Adjust scroll position to maintain visual position
							el.scrollTop = prevScrollTop + heightDifference;

							// Update the last scroll position to prevent loops
							lastScrollTop[id] = el.scrollTop;
						}

					}, 100);
				});

				// USER TOUCH INTERACTION - Take over autoscroll on touch
				var touchStartY = 0;
				var touchEndY = 0;
				var isUserScrolling = false;
				var userScrollTimeout;

				$('.column-mobile').on('touchstart', function (e) {
					touchStartY = e.originalEvent.touches[0].clientY;
					isUserScrolling = true;

					// Kill all autoscroll animations when user starts touching
					$('.column-mobile').each(function (index, el) {
						gsap.killTweensOf(el);
					});
				});

				$('.column-mobile').on('touchmove', function (e) {
					if (isUserScrolling) {
						touchEndY = e.originalEvent.touches[0].clientY;

						// Clear any existing timeout
						clearTimeout(userScrollTimeout);
					}
				});

				$('.column-mobile').on('touchend', function (e) {
					if (isUserScrolling) {
						var deltaY = touchStartY - touchEndY;
						var direction = deltaY > 0 ? 1 : -1;

						isUserScrolling = false;

						/*
						Scroll $('.column-mobile') from top
						*/
						$('.column-mobile').each(function (index, el) {
							gsap.killTweensOf(el);
							var scrollHeight = el.scrollHeight;
							var target = el.scrollTop + (deltaY * 2); // Boost amount for
							gsap.to(el, {
								scrollTop: target,
								duration: 0.4,
								ease: "power2.out",
								onComplete: function () {
									specific_showcase.restartAutoScroll(el, direction);
								}
							});
						});

						// // Wait a bit after user stops touching, then restart autoscroll
						// userScrollTimeout = setTimeout(function () {
						// 	$('.column-mobile').each(function (index, el) {
						// 		specific_showcase.restartAutoScroll(el, direction);
						// 	});
						// }, 1500); // 1.5 second delay before resuming autoscroll
					}
				});

				// Also add wheel support for mobile (when testing on desktop)
				$(window).on('wheel', function (e) {
					// Don't prevent default on mobile - allow natural scrolling

					var delta = e.originalEvent.deltaY;
					var direction = delta > 0 ? 1 : -1;

					$('.column-mobile').each(function (index, el) {
						gsap.killTweensOf(el);

						// For mobile, use smaller boost amount
						var boostAmount = delta * 2;
						var target = el.scrollTop + boostAmount;

						gsap.to(el, {
							scrollTop: target,
							duration: 0.4,
							ease: "power2.out",
							onComplete: function () {
								specific_showcase.restartAutoScroll(el, direction);
							}
						});
					});
				});

				/*
				Autoscroll
				*/
				$('.column-mobile').each(function () {
					var $col = $(this);
					var scrollHeight = this.scrollHeight;
					this.scrollTop = scrollHeight * 0.50;

					var el = this;
					specific_showcase.restartAutoScroll(el);
				});

			})
			.always(function () {
			});

	};

	/*
	Restart auto scroll
	*/
	this.restartAutoScroll = function (el, direction, recursionDepth) {

		if (!el || !el.scrollHeight) return;

		// if (el._isAutoScrolling) return; // Nieuw: voorkomt dubbele aanroepen
		// el._isAutoScrolling = true;

		setTimeout(function () {
			recursionDepth = recursionDepth || 0;
			if (recursionDepth > 100) return;

			var dir = direction || 1;
			var scrollStep = 150;
			var current = el.scrollTop;
			var target = current + (scrollStep * dir);

			var maxScroll = el.scrollHeight - el.clientHeight;
			if (target > maxScroll) target = maxScroll;
			if (target < 0) target = 0;

			gsap.killTweensOf(el);

			gsap.to(el, {
				scrollTop: target,
				duration: 3 + Math.random() * 2,
				ease: "none",
				onComplete: function () {
					//el._isAutoScrolling = false; // Nieuw: scroll is weer vrij

					specific_showcase.restartAutoScroll(el, dir, recursionDepth + 1);
				}
			});

			specific_showcase.PlayAndPauseVideos();

		}, 500);

	};

	this.observeNewVideos = function () {
		document.querySelectorAll('video[data-src]').forEach(function(video) {
			if (!video.dataset.observed) {
				_videoObserver.observe(video);
				video.dataset.observed = "true";
			}
		});
	};

	/*
	PlayAndPauseVideos *******************************************
	PlayAndPauseVideos *******************************************
	PlayAndPauseVideos *******************************************
	PlayAndPauseVideos *******************************************
	*/
	this.PlayAndPauseVideos = function () {

		// Initieel observeren
		specific_showcase.observeNewVideos();

	};

}).apply(specific_showcase);